import React, { useState } from 'react';
import Layout from '../components/Layout';

const Careers = () => {
  const [openPanel, setOpenPanel] = useState(null);

  const togglePanel = (panelId) => {
    setOpenPanel(openPanel === panelId ? null : panelId);
  };

  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Careers</h1>
                <p className="colorWht">Check out our open positions.</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="panel-group careers" role="tablist" aria-multiselectable="true">
                  <div className="panel panel-default">
                    <div className="panel-heading" role="tab" id="headingOne">
                      <h4 className="panel-title">
                        <a
                          role="button"
                          href="#collapseOne"
                          onClick={(e) => {
                            e.preventDefault();
                            togglePanel('collapseOne');
                          }}
                          aria-expanded={openPanel === 'collapseOne'}
                          aria-controls="collapseOne"
                        >
                          <p className="marB5 font22 pull-left">
                            Job Title: Developer{' '}
                            <div className="pull-right font30">
                              <i className="fa fa-arrow-circle-o-down"></i> Open
                            </div>
                          </p>
                          <div className="clearfix"></div>
                          <p className="mar0 font12 pull-left">
                            <strong>Exp:</strong> 3+ Years, <strong>Skills:</strong> Java, J2EE, JSF Primefaces...
                            <div className="pull-right font12">
                              Posted Date: 15-06-2016 <br /> No.of Positions: 1
                            </div>
                          </p>
                          <div className="clearfix"></div>
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseOne"
                      className={`panel-collapse collapse ${openPanel === 'collapseOne' ? 'in' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingOne"
                    >
                      <div className="panel-body">
                        <p>Skills required:</p>
                        <p>
                          <strong>Primary</strong> - Core Java, Java J2EE, JSF Primefaces, AJAX, MySQL, Hibernate, Eclipse IDE, Maven, Highfaces, Apache ActiveMQ JMS, WebSockets, Web services, Knowledge of Agile model of work.
                        </p>
                        <p>
                          <strong>Secondary</strong> - Java Mail, Oracle SQL, JQuery, Javascript, JPA, UNIX, GPS and Maps, Android, Highcharts, Java networking.
                        </p>
                        <p>Preferable experience on domains : Logistics, Transportation, Financial accounting, and Payroll.</p>
                        <p>
                          <strong>Job Description:</strong>
                        </p>
                        <ul>
                          <li>The individual will be responsible for Development of Transport Management ERP product based system.</li>
                          <li>Should be able to work in an rapid learning model environment, should be a team player.</li>
                          <li>Good experience on JAVA J2EE life cycle management and analytical skills.</li>
                          <li>Good leadership qualities. Having extensive knowledge on reporting tools, Development and Testing management tools</li>
                          <li>Minimum of 3+ years experience in JAVA J2EE (JSF)</li>
                        </ul>
                        <table className="table table-bordered table-responsive">
                          <tr className="active">
                            <td width="200">Salary</td>
                            <td>2,50,000 - 3,50,000 P. A. Plus Incentives (negotiable)</td>
                          </tr>
                          <tr className="">
                            <td width="200">Role</td>
                            <td>Software Engineer - Project Lead</td>
                          </tr>
                          <tr className="active">
                            <td width="200">Working Location</td>
                            <td>TIDEL PARK, Coimbatore</td>
                          </tr>
                          <tr className="">
                            <td width="200">
                              <strong>NOTE</strong>
                            </td>
                            <td>Individual must have primary skills.</td>
                          </tr>
                        </table>
                        <p>
                          Send your resume to{' '}
                          <a href="mailto:hrmanager@greenorange.in">
                            <strong>hrmanager@greenorange.in</strong>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="panel-group careers" role="tablist" aria-multiselectable="true">
                  <div className="panel panel-default">
                    <div className="panel-heading" role="tab" id="headingFour">
                      <h4 className="panel-title">
                        <a
                          role="button"
                          href="#collapseFour"
                          onClick={(e) => {
                            e.preventDefault();
                            togglePanel('collapseFour');
                          }}
                          aria-expanded={openPanel === 'collapseFour'}
                          aria-controls="collapseFour"
                        >
                          <p className="marB5 font22 pull-left">
                            Job Title: Liferay Delevoper{' '}
                            <div className="pull-right font30">
                              <i className="fa fa-arrow-circle-o-down"></i> Open
                            </div>
                          </p>
                          <div className="clearfix"></div>
                          <p className="mar0 font12 pull-left">
                            <strong>Exp:</strong> 3 - 5 Years, <strong>Skills:</strong> Primary : Liferay 7, Liferay Hook, Ext theme, Template,....
                            <div className="pull-right font12">
                              Posted Date: 31-03-2017 <br /> No.of Positions: 1
                            </div>
                          </p>
                          <div className="clearfix"></div>
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseFour"
                      className={`panel-collapse collapse ${openPanel === 'collapseFour' ? 'in' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingFour"
                    >
                      <div className="panel-body">
                        <p>Skills required:</p>
                        <p>
                          <strong>Primary </strong> - Liferay 7, Liferay Hook, Ext theme, Template, JSF, Spring, MVC, Hibernate, Json, HTML5, Velocity, Core Java, Java J2EE, Eclipse IDE, Maven, LINUX.
                        </p>
                        <p>
                          <strong>Secondary</strong> - Java Mail, JSF Primefaces, AJAX, MySQL, Oracle SQL, JQuery, Javascript, Java networking, Knowledge of Agile model of work.
                        </p>
                        <p>Preferable experience on domains : Logistics, Transportation, Financial accounting, and Payroll.</p>
                        <p>
                          <strong>Job Description:</strong>
                        </p>
                        <ul>
                          <li>The individual will be responsible for Development of Liferay Portal from the scratch.</li>
                          <li>Should be able to work in an rapid learning model environment, should be a team player.</li>
                          <li>Good experience on Liferay , JAVA J2EE life cycle management and analytical skills.</li>
                          <li>Good leadership qualities. Having extensive knowledge on handling Portal Development and Testing management tools.</li>
                          <li>
                            Minimum of 3 - 5yrs experience in Liferay <strong>(any 3 of secondary skills is mandatory)</strong>
                          </li>
                        </ul>
                        <table className="table table-bordered table-responsive">
                          <tr className="active">
                            <td width="200">Salary</td>
                            <td>4,00,000 - 6,00,000 P. A. Plus Incentives (negotiable)</td>
                          </tr>
                          <tr className="">
                            <td width="200">Role</td>
                            <td>Software Engineer – Associate.</td>
                          </tr>
                          <tr className="active">
                            <td width="200">Working Location</td>
                            <td>TIDEL PARK, Coimbatore</td>
                          </tr>
                          <tr className="">
                            <td width="200">
                              <strong>NOTE</strong>
                            </td>
                            <td>Individual must have primary skills.</td>
                          </tr>
                        </table>
                        <p>
                          Send your resume to{' '}
                          <a href="mailto:hrmanager@greenorange.in">
                            <strong>hrmanager@greenorange.in</strong>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <iframe
                  src="http://greenorange.webhr.co/hr/careers/"
                  style={{ marginTop: '0px', marginLeft: '0px', width: '100%', height: '400px' }}
                  frameBorder="0"
                  marginHeight="0"
                  marginWidth="0"
                  scrolling="auto"
                  title="Careers"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Careers;

